<lib-web-fixture
  [winnerId]="winner()"
  [breakerId]="breaker().id"
  [playerOneId]="breaker().id"
  [playerTwoId]="opponent().id"
  [infoTop]="(played() | date: 'mediumDate') ?? undefined"
  [infoBottom]="infoBottom()"
/>
@if (editable()) {
  <lib-web-result-action-buttons
    [muted]="!!winner()"
    [complete]="!!winner()"
    [editQueryParams]="{ edit: matchNo() }"
    [deleteQueryParams]="winner() ? { delete: matchNo() } : undefined"
  />
}
